import { curry, get } from 'lodash';
import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

export const NAME =
  'compositions_TechAdmin_DealerDetails_Contacts_contactEventsQuery';

const query = gql`
  query ${NAME} (
    $contactId: ID!
  ) {
    afterHoursContactEvents (
      input: {
        id: $contactId,
      }
    ) {
      events {
        id
        startTime
        endTime
        startDate
        endDate
        isRecurring
        options {
          recurringStartDate
          recurringEndDate
        }
        recurring {
          dayOfWeek
        }
        primaryContact {
          id
          name
          primaryPhoneNumber
          secondaryPhoneNumber
          jobTitle
          canDelete
        }
        backupContact {
          id
          name
          primaryPhoneNumber
          secondaryPhoneNumber
          jobTitle
          canDelete
        }
        finalContact {
          id
          name
          primaryPhoneNumber
          secondaryPhoneNumber
          jobTitle
          canDelete
        }
      }
    }
  }
`;

export function skipQuery(contactId) {
  return !contactId;
}

export function buildQueryVariables(contactId) {
  return { contactId };
}

export const buildQueryChild = curry(
  (WrappedComponent, componentProps, queryProps) => {
    const { data } = queryProps;
    const events = get(data, 'afterHoursContactEvents.events', []);
    return <WrappedComponent {...componentProps} events={events} />;
  },
);

function buildWrappedComponentWithQuery(WrappedComponent, componentProps) {
  const { contact } = componentProps;
  return (
    <Query
      query={query}
      skip={skipQuery(contact.id)}
      variables={buildQueryVariables(contact.id)}
      fetchPolicy="network-only"
    >
      {buildQueryChild(WrappedComponent, componentProps)}
    </Query>
  );
}

const withContactEvents = WrappedComponent => componentProps =>
  buildWrappedComponentWithQuery(WrappedComponent, componentProps);

export default withContactEvents;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/Contacts/DeleteContactModal/withContactEvents.js